import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Header extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.header}>
                <div className={styles.minibox}>
                    <div className={styles.minihead}>
                        <div className={styles.minilogo}>
                            <a href="http://v.ifeng.com/" target="_blank" title="凤凰视频" id="js_vtop_logo">
                                凤凰视频
                            </a>
                        </div>
                        <div className={styles.mininav}>
                            <ul>
                                <li title="首页">
                                    <a href="http://v.ifeng.com/" target="_blank">
                                        首页
                                    </a>
                                </li>
                                <li title="资讯">
                                    <a href="http://v.ifeng.com/news/" target="_blank">
                                        资讯
                                    </a>
                                </li>
                                <li title="娱乐">
                                    <a href="http://v.ifeng.com/ent/" target="_blank">
                                        娱乐
                                    </a>
                                </li>
                                <li title="影视">
                                    <a href="http://v.ifeng.com/film/" target="_blank">
                                        影视
                                    </a>
                                </li>
                                <li title="军事">
                                    <a href="http://v.ifeng.com/mil/" target="_blank">
                                        军事
                                    </a>
                                </li>
                                <li title="体育">
                                    <a href="http://v.ifeng.com/sports/" target="_blank">
                                        体育
                                    </a>
                                </li>
                                <li title="佛教">
                                    <a href="http://v.ifeng.com/fo/" target="_blank">
                                        佛教
                                    </a>
                                </li>
                                <li title="人文">
                                    <a href="http://v.ifeng.com/humanity/" target="_blank">
                                        人文
                                    </a>
                                </li>
                                <li title="科技">
                                    <a href="http://v.ifeng.com/keji/" target="_blank">
                                        科技
                                    </a>
                                </li>
                                <li title="时尚">
                                    <a href="http://v.ifeng.com/fashion/" target="_blank">
                                        时尚
                                    </a>
                                </li>
                                <li title="生活">
                                    <a target="_blank" href="http://v.ifeng.com/life/">
                                        生活
                                    </a>
                                </li>
                                <li title="汽车">
                                    <a href="http://v.ifeng.com/car/" target="_blank">
                                        汽车
                                    </a>
                                </li>
                                <li title="旅游">
                                    <a href="http://v.ifeng.com/tourism/" target="_blank">
                                        旅游
                                    </a>
                                </li>
                                <li title="美食">
                                    <a href="http://v.ifeng.com/food/" target="_blank">
                                        美食
                                    </a>
                                </li>
                                <li title="公开课">
                                    <a href="http://v.ifeng.com/gongkaike/" target="_blank">
                                        公开课
                                    </a>
                                </li>
                                <li className={styles.last} title="涨知识">
                                    <a href="http://v.ifeng.com/knowledge/" target="_blank">
                                        涨知识
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.minisearch}>
                            <form target="_blank" action="http://so.v.ifeng.com/video" method="get">
                                <input type="text" autoComplete="off" className={styles.ipttxt} name="q" />
                                <input type="hidden" value="5" name="c" id="param1" />
                                <input type="hidden" disabled="" value="" name="" id="param2" />
                                <input type="submit" value="" className={styles.iptbtn} />
                            </form>
                        </div>
                        <div className={styles.minilogin}>
                            <ul>
                                <li className={styles.last} title="凤凰首页">
                                    <a target="_blank" href="http://www.ifeng.com/">
                                        凤凰首页
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={styles.banner}>
                    <h1 style={{ backgroundImage: `url(${content.src})` }}>
                        刘长乐 太平绅士 凤凰卫视董事局主席、行政总裁
                    </h1>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
